module.exports = __webpack_public_path__ + "img/supervisor-intro-three.04f2ed62.png";